import { render, staticRenderFns } from "./packageAgent.vue?vue&type=template&id=dcc97416&scoped=true"
import script from "./packageAgent.vue?vue&type=script&lang=js"
export * from "./packageAgent.vue?vue&type=script&lang=js"
import style0 from "./packageAgent.vue?vue&type=style&index=0&id=dcc97416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc97416",
  null
  
)

export default component.exports